module.exports = __webpack_public_path__ + "img/users-black.0be0d78d.svg";